export const detectOSAndBrowser = (userAgent: string) => {
  let os = "Unknown OS";
  if (/Windows NT/.test(userAgent)) os = "Windows";
  else if (/Mac OS X/.test(userAgent)) os = "macOS";
  else if (/Android/.test(userAgent)) os = "Android";
  else if (/iPhone|iPad|iPod/.test(userAgent)) os = "iOS";
  else if (/Linux/.test(userAgent)) os = "Linux";

  let browser = "Unknown Browser";
  if (/Edg\//.test(userAgent)) browser = "Edge";
  else if (/OPR\//.test(userAgent)) browser = "Opera";
  else if (
    /Chrome\//.test(userAgent) &&
    !/Edg\//.test(userAgent) &&
    !/OPR\//.test(userAgent)
  )
    browser = "Chrome";
  else if (/Safari\//.test(userAgent) && !/Chrome\//.test(userAgent))
    browser = "Safari";
  else if (/Firefox\//.test(userAgent)) browser = "Firefox";
  else if (/MSIE|Trident\//.test(userAgent)) browser = "Internet Explorer";

  return { os, browser };
};

export const isTouchDevice = () =>
  "ontouchstart" in window || navigator.maxTouchPoints > 0;
